import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "component"
}

import { PropType } from 'vue';
import { HardwareComponent } from '@/models/hardware.model';
import Property from '@/components/system/components/Property.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CPU',
  props: {
  component: {
    type: Object as PropType<HardwareComponent | null>,
    required: true,
  },
  full: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const { component } = __props;



return (_ctx: any,_cache: any) => {
  return (__props.component)
    ? (_openBlock(), _createElementBlock("li", _hoisted_1, [
        _createElementVNode("div", null, _toDisplayString(__props.component.fullName), 1),
        _createVNode(Property, {
          component: __props.component,
          property: "socket",
          label: __props.full ? 'Socket' : ''
        }, null, 8, ["component", "label"]),
        _createVNode(Property, {
          component: __props.component,
          property: "basefrequency",
          label: __props.full ? 'Base Frequency' : ''
        }, null, 8, ["component", "label"]),
        _createVNode(Property, {
          component: __props.component,
          property: "cores",
          label: __props.full ? 'Cores' : '',
          suffix: __props.full ? '' : ' /'
        }, null, 8, ["component", "label", "suffix"]),
        _createVNode(Property, {
          component: __props.component,
          property: "threads",
          label: __props.full ? 'Threads' : ''
        }, null, 8, ["component", "label"]),
        _createVNode(Property, {
          component: __props.component,
          property: "cache",
          label: __props.full ? 'Cache' : ''
        }, null, 8, ["component", "label"])
      ]))
    : _createCommentVNode("", true)
}
}

})